import { useMutation, useQueryClient } from '@tanstack/react-query';

import { contentDeploymentKeys } from './keys';
import { refreshContent } from './refreshContent';

export function useRefreshContent() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: refreshContent,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: contentDeploymentKeys.all });
    },
  });
}
